module.exports = __webpack_public_path__ + "static/media/btn_team.6078024f.png";